import { Component, Input } from '@angular/core';
import { AlertService } from '@forgerock/backstage-ui-core';
import { UserAccountService } from '../user-account.service';

@Component({
    selector: 'app-dashboard-verify-email-panel',
    templateUrl: './dashboard-verify-email-panel.component.html',
    styleUrls: ['./dashboard-verify-email-panel.component.scss'],
    standalone: false
})
export class DashboardVerifyEmailPanelComponent {
  @Input() emailVerifiedUntil: Date | null = null;

  constructor(private readonly userAccountService: UserAccountService,
              private readonly alertService: AlertService) { }

  async sendVerificationEmail(): Promise<void> {
    try {
      await this.userAccountService.sendVerificationEmail();
      this.alertService.success('A verification token has been sent to your email address');
    } catch (err) {
      this.alertService.error(err);
    }
  }
}
